import { SvgIcon } from '@ethings/ui-toolkit';
import { SvgIconProps, SxProps, Theme } from '@mui/material';
import { CSSProperties, FC } from 'react';

interface StyledSvgIconProps extends SvgIconProps {
  sx?: SxProps<Theme>;
}

const sxToCss = (sx: StyledSvgIconProps['sx']): CSSProperties | undefined => {
  if (!sx || typeof sx !== 'object' || Array.isArray(sx)) {
    return undefined;
  }

  return sx as CSSProperties;
};

const StyledSvgIcon: FC<StyledSvgIconProps> = ({ sx, style, ...props }) => {
  const sxAsCss = sxToCss(sx);

  return <SvgIcon {...props} style={{ ...(sxAsCss ?? {}), ...(style ?? {}) }} />;
};

export const CircleIcon: FC<SvgIconProps> = ({ sx, ...props }) => (
  <StyledSvgIcon {...props} sx={sx}>
    <path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2"></path>
  </StyledSvgIcon>
);
